<template>
    <div class="bgView" :style="{fontSize:fontsize,width:screenWidth}" id="areaCockpit">
        <div class="bk" :style="{fontSize:fontsize,width:screenWidth}">
            <div class="bg" :style="{fontSize:fontsize,width:screenWidth}">
                <div :style="{width:viewWidth,height:viewHeight}" class="containerView">
                    <!--頂部 start-->
                    <div style="width:100%;height:7%;margin-bottom: 2%;">
                    </div>
                    <!--頂部 end-->

                    <div class="operationView">
                        <div class="flex-view-style j-c-f">
                            <div class="entranceView c-pointer"
                                 @click="goPCWeb">
                            </div>


                            <v-menu dark bottom offset-y>
                                <template v-slot:activator="{ on }">
                                    <div v-on="on"
                                         class="workBench c-pointer">
                                    </div>
                                </template>

                                <!--<v-list  style="background-color:#012E7B;margin-top:10px;">-->
                                <v-list style="margin-top:10px;">
                                    <v-list-item
                                            v-for="(item, index) in routers[0].children"
                                            :key="item.name"
                                            @click="changeMenu(item)"
                                    >
                                        <v-list-item-title>{{ item.meta.title }}</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>

                            <!--<div class="workBench c-pointer"-->
                            <!--@click.stop="drawer = !drawer">-->
                            <!--</div>-->

                        </div>

                        <div class="flex-view-style j-c-f">

                            <v-menu dark bottom offset-y>

                                <template v-slot:activator="{ on }">
                                    <!--查找医院设备-->
                                    <div v-on="on"
                                         class="selectHospital c-pointer">
                                        <input style="width:100%;font-size:0.8rem;font-weight: bold;height:100%;color:#fff;outline: none;padding-left:3.1rem;padding-right:0.2rem;"
                                               @input="queryInputChange"
                                               v-model="queryInputValue"
                                               type="text" placeholder="查找医院设备">
                                    </div>
                                </template>

                               <v-list style="margin-top:10px;">
                                    <div v-if="list.length>0" style="max-height: 80vh;overflow-y: auto">
                                        <v-list-item
                                                v-for="(item, index) in list"
                                                :key="item.id"
                                                @click="chooseHospital(item)"
                                        >
                                            <v-list-item-title style="font-size:0.9em;">{{ item.hospName}}
                                            </v-list-item-title>
                                        </v-list-item>
                                    </div>
                                    <div v-else>
                                        <v-list-item>
                                            <v-list-item-title style="font-size:0.9em;">无匹配数据
                                            </v-list-item-title>
                                        </v-list-item>
                                    </div>
                                </v-list>
                            </v-menu>

                            <div class="setUpView">
                                <z-set-up height="20">
                                    <template v-slot>
                                        <v-img src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/shezhi.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001585121738&Signature=0tFLpeuVNJHLsTSLWooOG7WRgx4%3D"
                                               contain
                                               height="1.3rem"></v-img>
                                    </template>
                                </z-set-up>
                            </div>


                        </div>

                    </div>

                    <!--底部内容區域 start-->
                    <div class="bottomDiv">

                        <div class="bottom_left">

                            <!--设备运行状况 start-->
                            <div class="statsDiv">
                                <div class="div_top_title">设备运行状况</div>
                                <div class="flex-view-style">
                                    <div class="flex-view-style flex-d-c">
                                        <img class="rotate_img" src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/nm.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1000001605162531&Signature=NZLbHmvC%2F9KHYsrwzfkFbLHTRno%3D" alt="">
                                        <div style="margin:0.7em;">正常</div>
                                        <div style="color: #0DFAFF;">
                                            <span style="font-size:1.2em;">
                                                {{!eqpStateNumList.normalCount?0:eqpStateNumList.normalCount}}
                                            </span>台
                                        </div>
                                    </div>
                                    <div class="flex-view-style flex-d-c">
                                        <img class="rotate_img" src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/wr.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=10001605163192&Signature=JelPDY%2Fa9SUrEioBCZoxvnMLe9g%3D" alt="">
                                        <div style="margin:0.7em;">预警</div>
                                        <div style="color: #0DFAFF;">
                                            <span style="font-size:1.2em;">
                                                {{!eqpStateNumList.warningCount?0:eqpStateNumList.warningCount}}
                                            </span>台
                                        </div>
                                    </div>
                                    <div class="flex-view-style flex-d-c">
                                        <img class="rotate_img" src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/lx.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001605163305&Signature=plMsSmxktvPEfVD%2F3g110bjYADg%3D" alt="">
                                        <div style="margin:0.7em;">离线</div>
                                        <div style="color: #0DFAFF;">
                                            <span style="font-size:1.2em;">
                                                {{!eqpStateNumList.offlineCount?0:eqpStateNumList.offlineCount}}
                                            </span>台
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!--设备运行状况 end-->

                            <!--实时运行参数预警 start-->
                            <div class="realTimeData">
                                <div class="div_top_title">实时运行参数预警</div>
                                <div class="flex-view-style" style="justify-content: flex-end">
                                    <div class="warningSum">
                                        数量：<span>{{eqpWarningList.length}}</span>个
                                    </div>
                                </div>
                                <div class="warningList">
                                    <z-scroll-component :index="0" ref="eqpWarningView">
                                        <div class="flex-view-style warningItem"
                                             v-for="(item,index) in eqpWarningList" :key="index">
                                            <div>
                                                <div class="hospName">{{item.hospName}}</div>
                                                <div>
                                                    <span class="mr-2">{{item.eqpName}}</span>
                                                    <span>{{item.hospEqpId}}</span>
                                                    <div style="color:#FFC600;">
                                                        <span>{{item.statusData}}</span>
                                                    </div>
                                                </div>
                                                <div>{{item.statusStartDateTime}}</div>
                                            </div>
                                            <img style="width:3rem"
                                                 src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/unlock_ic.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=10001585118550&Signature=EJFnBkK9uaWcq8Y4kv6FFh%2B%2F20s%3D"
                                                 alt="">
                                        </div>
                                    </z-scroll-component>
                                </div>
                            </div>
                            <!--实时运行参数预警 end-->

                        </div>

                        <!--工单统计 待修设备监控 start-->
                        <div class="bottom_center">
                            <!--入网医院总览，入网设备总览 start-->
                            <div class="flex-view-style b-c-t j-c-c">
                                <div>
                                    <div class="b-c-t-t">入网医院</div>
                                    <div>
                                        <span class="f-s-50" style="margin-right:16px;">{{dataDetail.hospSum}}</span>家
                                    </div>
                                </div>
                                <div>
                                    <div class="b-c-t-t">入网设备</div>
                                    <div>
                                        <span class="f-s-50" style="margin-right:16px;">{{dataDetail.eqpSum}}</span>台
                                    </div>
                                </div>
                            </div>
                            <!--入网医院总览，入网设备总览 end-->

                            <div class="b-c-c">
                                <div style="width:100%;height:100%;">
                                    <div id="areaEcharts">
                                    </div>
                                </div>
                            </div>

                            <!--地图底部转动弹框 start-->
                            <div class="b-c-c-b">
                            </div>
                            <!--地图底部转动弹框 end-->

                        </div>
                        <!--工单统计 待修设备监控 end-->

                        <!--右侧区域 start-->
                        <div class="bottom_right">

                            <!--设备环境监控 start-->
                            <div class="runingState">
                                <div class="div_top_title">设备环境监控</div>

                                <div class="flex-view-style">
                                    <div class="flex-view-style flex-d-c">
                                        <img class="rotate_img" src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/nm.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1000001605162531&Signature=NZLbHmvC%2F9KHYsrwzfkFbLHTRno%3D" alt="">
                                        <div style="margin:0.7em;">正常</div>
                                        <div style="color: #0DFAFF;">
                                            <span style="font-size:1.2em;">
                                                {{!stateNumList.normalCount?0:stateNumList.normalCount}}
                                            </span>台
                                        </div>
                                    </div>
                                    <div class="flex-view-style flex-d-c">
                                        <img class="rotate_img" src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/wr.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=10001605163192&Signature=JelPDY%2Fa9SUrEioBCZoxvnMLe9g%3D" alt="">
                                        <div style="margin:0.7em;">预警</div>
                                        <div style="color: #0DFAFF;">
                                            <span style="font-size:1.2em;">
                                                {{!stateNumList.warningCount?0:stateNumList.warningCount}}
                                            </span>台
                                        </div>
                                    </div>
                                    <div class="flex-view-style flex-d-c">
                                        <img class="rotate_img" src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/lx.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001605163305&Signature=plMsSmxktvPEfVD%2F3g110bjYADg%3D" alt="">
                                        <div style="margin:0.7em;">离线</div>
                                        <div style="color: #0DFAFF;">
                                            <span style="font-size:1.2em;">
                                                {{!stateNumList.offlineCount?0:stateNumList.offlineCount}}
                                            </span>台
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <!--实时环境数据 end-->

                            <!--实时环境数据预警  start-->
                            <div class="realTimeData">
                                <div class="div_top_title">实时环境数据预警</div>
                                <div class="flex-view-style" style="justify-content: flex-end">
                                    <div class="warningSum">
                                        数量：<span>{{warningList.length}}</span>个
                                    </div>
                                </div>
                                <div class="warningList">
                                    <z-scroll-component :index="1" ref="warningView">
                                        <div class="flex-view-style warningItem"
                                             v-for="(item,index) in warningList" :key="index">
                                            <div @click="goToRealTime(item.hospId,item.collectorId)">
                                                <div class="hospName">{{item.hospName}}</div>
                                                <div>
                                                    <span class="mr-2">{{item.eqpName != null ? item.eqpName : item.roomName != null ? item.roomName : item.deptName}}</span>
                                                    <span>{{item.hospEqpId}}</span>
                                                    <div style="color:#FFC600;">
                                                        <span>{{item.statusData}}</span>
                                                    </div>
                                                </div>
                                                <div>{{item.statusStartDateTime}}</div>
                                            </div>
                                            <img style="width:3rem"
                                                 src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/unlock_ic.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=10001585118550&Signature=EJFnBkK9uaWcq8Y4kv6FFh%2B%2F20s%3D"
                                                 alt="">
                                        </div>
                                    </z-scroll-component>
                                </div>
                            </div>
                            <!--实时环境数据预警  end-->

                        </div>
                        <!--右侧区域 end-->

                    </div>
                    <!--底部内容區域 end-->

                </div>
            </div>
        </div>

        <!--<z-menu v-model="drawer"></z-menu>-->

    </div>
</template>
<script>
    import ZScrollComponent from "@/components/ZScrollComponent"
    import Vue from 'vue'
    import ZMenu from "@/components/ZMenu"
    import {
        collectorStatusQuery,
        hospCollectorWaringQuery,
        iotPlatformInfo,
        queryHospCollectCount,
        mapHospQuery,
        provinceHospQuery,
        eqpWarnLogListQuery,
        eqpWarnStatusQuery
    } from '@/api/dataPlatform'
    import {mapGetters} from 'vuex'
    import ZSetUp from "@/components/ZSetUp"
    import {errorNotify} from "../../utils/alertutil";
	// import { getAcctMenus} from './api/login'

    export default {
        name: 'areaBigScreen',
        data() {
            return {
                searchText: '',
                hospitalList: [],
                drawer: false,
                dataDetail: {
                    hospSum: '0',
                    eqpSum: '0',
                },
                isFullscreen: false,
                viewWidth: '',
                viewHeight: '',
                screenWidth: '',
                fontsize: '',
                eqpChart: null,
                coordinateList: [
                    // {
                    //   hospName: "汉口医院",
                    //   value: [114.307149, 30.631403],
                    //   statusData: '温度 68°C',
                    //   deptName: '放射科',
                    //   roomName: "房间名称",
                    //   eqpName: '设备名称',
                    //   statusStartDateTime: '2020-12-12 12:12:12'
                    // },
                    // {
                    //   hospName: "汉口医院111",
                    //   value: [116.420366, 39.983965],
                    //   statusData: '温度 68°C',
                    //   deptName: '放射科',
                    //   roomName: "房间名称",
                    //   eqpName: '设备名称',
                    //   statusStartDateTime: '2020-12-12 12:12:12'
                    // },
                ],
                hospitalAreaList: [
                    // {
                    //   hospName: "汉口医院",
                    //   value: [114.307149, 30.631403],
                    //   statusData: '温度 68°C',
                    //   deptName: '放射科',
                    //   roomName: "房间名称",
                    //   eqpName: '设备名称',
                    //   statusStartDateTime: '2020-12-12 12:12:12'
                    // },
                    // {
                    //   hospName: "汉口医院111",
                    //   value: [116.420366, 39.983965],
                    //   statusData: '温度 68°C',
                    //   deptName: '放射科',
                    //   roomName: "房间名称",
                    //   eqpName: '设备名称',
                    //   statusStartDateTime: '2020-12-12 12:12:12'
                    // },
                    // {
                    //   hospName: "汉口医院1211",
                    //   value: [112.561364, 25.287718],
                    //   statusData: '温度 68°C',
                    //   deptName: '放射科',
                    //   roomName: "房间名称",
                    //   eqpName: '设备名称',
                    //   statusStartDateTime: '2020-12-12 12:12:12'
                    // },
                ],
                stateNumList: {
                    normalCount: 0,
                    offlineCount: 0,
                    warningCount: 0
                },

                eqpStateNumList: {
                    normalCount: 0,
                    offlineCount: 0,
                    warningCount: 0
                },


                iotList: [
                    {
                        placeName: '',
                        allCount: 0,
                        warningCount: 0
                    }
                ],
                iotInterval: null,
                speed: 3000,
                warningList: [
                    // {
                    //   "collectorId": "",
                    //   "sensorId": "",
                    //   "hospName": "",
                    //   "deptName": "",
                    //   "roomName": "",
                    //   "eqpName": "",
                    //   "collectPlace": "",
                    //   "longitude": "",
                    //   "latitude": "",
                    //   "statusStartDateTime": "",
                    //   "statusData": ""
                    // },
                ],
                eqpWarningList:[],
                intervalArea: null,
                areaIndex: 0,
                dataList: [
                    // {
                    //   name: '新疆维吾尔自治区',
                    //   value: '123',
                    //   hospCount:1,
                    //   hospList:[
                    //     {
                    //       hospCode:'001',
                    //       hospName:'新疆维吾尔自治区第一人民医院'
                    //     }
                    //   ]
                    // },
                    // {
                    //   name: '北京市',
                    //   value: '123',
                    //   hospCount:1,
                    //   hospList:[
                    //     {
                    //       hospCode:'001',
                    //       hospName:'北京市第一人民医院'
                    //     }
                    //   ]
                    // },
                    // {
                    //   name: '湖北省',
                    //   value: '123',
                    //   hospCount:1,
                    //   hospList:[
                    //     {
                    //       hospCode:'001',
                    //       hospName:'湖北省第一人民医院'
                    //     }
                    //   ]
                    // }
                ],
                queryInputValue: '',
                list: [],
                interval:null
            }
        },

        components: {
            ZScrollComponent,
            ZMenu,
            ZSetUp
        },

        watch: {
            queryInputValue(newValue, oldValue) {
                if (newValue) {
                    this.list = [];
                    for (var i = 0; i < this.hospitalList.length; i++) {
                        if (this.hospitalList[i].hospName.indexOf(newValue) != -1) {
                            this.list.push(this.hospitalList[i])
                        }
                    }
                } else {
                    this.list = this.hospitalList;
                }
            }
        },
        computed: {
            ...mapGetters([
                'routers',
            ]),
			
			
			
        },
		
        methods: {
            queryInputChange(val) {
                // console.log(val);
                // this.list=[];
                // for(var i=0;i<this.hospitalList.length;i++){
                //   if(this.hospitalList[i].hospName.indexOf(this.queryInputValue)!=-1){
                //     this.list.push(this.hospitalList[i])
                //   }
                // }
            },
            goPCWeb() {
                window.location.href = "http://hosp.zzitec.com";
            },
            changeMenu(item) {
                this.$store.dispatch('setCurretTitle', item.meta.title);
                this.$router.push({path: item.path});
            },
            goToRealTime(hospId,collectorId) {
              let toPath = '/real-time-data-monitor?id=' + hospId + '&businessId=' + collectorId;
              this.$router.push({path: toPath})
            },
            initAreaEcharts() {
                this.$nextTick((res) => {
                    let _this = this;
                    this.$.get('/areaJSON/100000_geojson_full.json', function (chinaJson) {
                        _this.$echarts.registerMap('全国地图', chinaJson);

                        _this.hospCollectorWaringQuery();

                    });
                })
            },
            setAreaEcharts() {
                // 重新绘制地图之前，销毁之前的echarts,否则zoom将继承之前的值
                this.$("#areaEcharts").removeAttr("_echarts_instance_").empty();
                var eqpChart = this.$echarts.init(document.getElementById('areaEcharts'));
                var arr = [];
                arr.push(this.coordinateList[this.areaIndex]);

                var options = {
                    tooltip: {
                        show: true,
                        backgroundColor: 'rgba(1,12,56,0.71)',
                        borderColor: '#17C7FC',
                        borderWidth: 1,
                        confine: false,
                        padding: 15,
                        enterable: true,
                        extraCssText: 'box-shadow: 0 0 10px #17C7FC inset;',
                        trigger: 'item',
                        triggerOn: 'click',
                        position: 'top',
                        formatter: (params) => {
                            let data = '';
                            let url = window.location.href;

                            if (params.seriesName == '地标') {

                                if("6048334c30e37939ddbb7143" ===params.data.hospId){
                                    let goToUrl = url.split('#')[0] + '#/real-time-data-monitor?id=' + params.data.hospId + '&businessId=' + params.data.collectorId;
                                    data = `<a href="${goToUrl}" style="color:#fff;text-decoration: none;"><div style="padding:0.2em 0.5em;font-size:0.875em;background-position:center;background-repeat:no-repeat;">
<div style="text-align:center;padding:0 2em;margin-bottom:0.2em;height:2em;line-height:2em;background-size:100% 100%;background-position:center;background-repeat:no-repeat;background-image: url('https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/qkbt.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001585137311&Signature=k508wNsxGOBvt3n9l4U4qzxq8Ck%3D')">${params.data.hospName}</div>
<div style="display: flex;align-items: center;justify-content: space-between;">
    <div style="padding:0.5em 1em 0.5em 0;">
        <div>${params.data.deptName}</div>
        <div>${params.data.eqpName != null ? params.data.eqpName : params.data.roomName}</div>
    </div>
    <div style="color:#FFA800;padding:0.5em;background-size:100% 100%;background-position:center;background-repeat:no-repeat;background-image: url('https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/tkwd.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001585137665&Signature=rQjrOp4QiQwSBz1cIaHKzlwJM2Q%3D')">${params.data.shortStatusData}</div>
</div>
<div>设备编号：${params.data.hospEqpId != null ? params.data.hospEqpId : "-"}</div>

<div style="color:#FFA800;">${params.data.statusData}</div>
<div>${params.data.statusStartDateTime}</div>
</div></a>`;
                                }else{
                                    data = `<a style="color:#fff;text-decoration: none;"><div style="padding:0.2em 0.5em;font-size:0.875em;background-position:center;background-repeat:no-repeat;">
<div style="text-align:center;padding:0 2em;margin-bottom:0.2em;height:2em;line-height:2em;background-size:100% 100%;background-position:center;background-repeat:no-repeat;background-image: url('https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/qkbt.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001585137311&Signature=k508wNsxGOBvt3n9l4U4qzxq8Ck%3D')">${params.data.hospName}</div>
<div style="display: flex;align-items: center;justify-content: space-between;">
    <div style="padding:0.5em 1em 0.5em 0;">
        <div>${params.data.deptName}</div>
        <div>${params.data.eqpName != null ? params.data.eqpName : params.data.roomName}</div>
    </div>
    <div style="color:#FFA800;padding:0.5em;background-size:100% 100%;background-position:center;background-repeat:no-repeat;background-image: url('https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/tkwd.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001585137665&Signature=rQjrOp4QiQwSBz1cIaHKzlwJM2Q%3D')">${params.data.shortStatusData}</div>
</div>
<div>设备编号：${params.data.hospEqpId != null ? params.data.hospEqpId : "-"}</div>
<div style="color:#FFA800;">${params.data.statusData}</div>
<div>${params.data.statusStartDateTime}</div>
</div></a>`;
                                }

                            }
                            return data;
                        },
                    },
                    geo: {
                        map: '全国地图',
                        zoom: 1.3,
                        label: {
                            normal: {
                                show: !0,
                                fontSize: "10",
                                color: "rgba(255,255,255)"
                            }
                        },
                        emphasis: { //当鼠标放上去  地区区域是否显示名称
                            label: {
                                show: true,
                                textStyle: {
                                    color: '#fff',
                                    fontSize: 10,
                                    backgroundColor: '#17C7FC'
                                }
                            }
                        },
                        scaleLimit: {
                            min: 0.5,
                            max: 3
                        },
                        aspectScale: 1,
                        layoutCenter: ['50%', '60%'],
                        layoutSize: '100%',
                        // 如果宽高比大于 1 则宽度为 100，如果小于 1 则高度为 100，保证了不超过 100x100 的区域
                        // layoutSize: '100%',
                        roam: true,
                        viewControl: {
                            alpha: 60
                        },
                        itemStyle: {
                            color: '#0a1967',
                            // opacity: 1,
                            borderWidth: 1,
                            borderColor: '#00A2FF',
                        },
                        //shading: 'lambert',
                        light: { //光照阴影
                            main: {
                                color: '#fff', //光照颜色
                                intensity: 1.2, //光照强度
                                // shadowQuality: 'high', //阴影亮度
                                // shadow: fasle, //是否显示阴影
                                alpha: 55,
                                beta: 10
                            },
                            ambient: {
                                intensity: 0.3
                            }
                        },
                    },
                    series: [
                        {
                            name: '地标',
                            type: 'scatter',
                            coordinateSystem: 'geo',
                            symbolSize: [30, 30],
                            symbol: 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE0AAABCCAYAAAASX1tlAAAOL0lEQVR4nOVcW28kRxX+TvVl7mPPemyv7d04bJKNWGCVQKIQIsRLACnKCz+ASAgkfhMvvMA7D0iICPEQEAHELTgsKM7Ve7HXt531eK7dXVXoVHfPtO0er8fT9hDxacvTXX2pqq/PqTrnVNWS1hqXjU/e/AE0wSJNGqQxqAKR+QtADw50dGCgwytEcZa68cufXnr97UsvkcFcgQSEMiRQkpSjN0bXdHwa/VHxDQpTwBRJ05ahg4z4EGdGIsY8RfKlQ8a0NnfELFKYwYLq/9+QRmQExAoZGuim+StilTQwEhlSOrhFRdxdfrcSYzqkmYZry8hUrJrMVNSJUayvkWpS3LEdU2NKe/klYDqkhX2ZrUmB4i6fIoWkUFv5UFOkqkbcFGtkdH8kizQd2qYkaZIbbHN3ZoggpUNBM+xwHlFInvkzVE1o1l/SIZd6SqI2pYFAxWXH7SZBoUQNRgDWUhH+IuKM1VYPR1hN/1eSJiLS9HCsjOkwRET5FLM6VNmwPxPRODslUbPxo9KlF0r0Oo58MBHZGsCgbzPQw1OdvCd53xTqP02Tww5Ns0gZBVtsFCkjEuIW2mQU2yeUpHQ6mBJpktvsIGJAxyYtDezcaESNzkX8pD4qhp870m7ePt9z62vOcuWderN/45Ygv0KkigRZAnSRSDlcJzKEhtAgtvoDaOFpUFfDamstOkrbh9Xcp48A7OHm7fE9g/W189X/UiRtfa0MYBXAdQDXQDQDy+7YFCxo4XgQtq/J6mvLbkFYUkNIkNADt10rIq0saGmRDBxomScVVGwVXIfl1CGDItbXDgDcB3APwAZu3m5dZJMuhrT1tSsAnjdJWDNwcwcolA5QqnyKQqnHqigf2F8ZxjMwDG4Qu1dqqImmy7MAIaQWjkTyoZXZ903X123n0T6sott+GV7/9YjED0y6eftR1s3LjrT1NX7XFwG8CMuuolDaR7X2AOXqh6n3GyZ0opuKhEsnzImB+6Qik2NopdEg8kFAsdwzCdgxea1mEc3G0+i2v4b1tSaAfwD4D27eDrJo6uSkra9VAbwAopeRL+5htr6FyszHT35QOhS75CE54TCJE+ZXxBQPnWzxgr2H0w20crWDcvUugLs4PCjh8d5X0et8B+trfwHwHm7ebk7SZNI/LJ73WTaQXgKJF1GZ2cTc4kM4rjzrw4f39atDjRxqaUwKDQVNR4aGjmMeccCoco3+dOba+p6F/e2rODxYhlYseX8F0D5Hu88tad8A0ddRrm5ifvlvsJ2xg4EEZRlykoQlwkLxL8UaGd6rkzYwR5fODP6gV68/QP3qFnY3V9Bq/hhaM+nvjlv3cUl7xqhivljF4rW/I5efIAionFjHkrr2JMfo6PUxSIvBH3hp9R76vYfYvv88ep0lo7LAGbqUEOOQ9hqE9RLmFj5GbX59/NoeBUHZQ4czNGOPuElh35aMNUZamZS0CcAf/Kln19HYrWF/500oyer6h7O88CykuQC+CTf3DJaffg9uLpMRCMS2V2j+6yi+QWFcLSYydtgpiohrJL2orByC2nwDpep72PzsS/D6eQC/B+Cd9siTSKuZzr5Uncfy6p0sg34EaccMxJMB8QEN/M/BIKEjPgf/Ej7o5GBBWL15B5sbq2g3vxUNEo1R7xWnFLjIMQTMXJnFytMb2UdJ2WWSNlhNzXGYiKQDdqeI88PrFOdD25xvzs1zGYLbx+3k9nK7w/anYlTBbHu9hVr9I8wv72TMlgEhsAdOeRTENvKjh+J1wjenlKOssXhtE0IEaOy9BeAnAE7YdKNIewXV2sZFERYSoCwyXoFyAWWBtAPSVuQYEImoE4s80DA0Qj60kAA77zizTTg2uN1SOmg2XgHwm+OPp5H2LeSLK7h6Pd39mRSq7yJozQrqLYDi6G30zmPSRSdtkkJ8TEyit78Au/wYIndqx30usE3ne8+i2+Y+7p3TSPsSLOs2Vp5+L/NKyHYRQbMO5XPUg9ueG8TNBsNlgrXkzHoytjbMsyDbdZOE04Jd3YNV6mRa5+XVT/DZBy9Ayj0Ad+LsJGlcozcwv/w+LDu76X7lO/D3F6G86pF8kpYpU0TeZTwrzHOiFJljiTmUUEVVPHEQefoiLqMMb78McdiEc2Ubws1m5p15mF/+EA/vvQHg3/EXS5L2KorlbVRrh5kUyAiaM/APriJagpCEWZYQGhV8aHPSWlgEIcK8aD7P6K9SICkBFQAyAFRE57HBnz9Mf7sEZ+Yh7OpBJm1gPpqNbXRar8YuV1yqDaJXMb98N5OCGN7eAvzHK2mEIezpc6TcCmR+lrRThhZ5AWJTwiJIAZIcdRPhORxoK8/3keL73Qo/n16wtky5XH5WYF6Yn0jIYtJuIV/cncyXTBK2exWyU0+9FhRzaK8uQTkVaHLJjJxMjBJgssyvElG+iBNRmG/OQS6kUzbv4felgcvnemQB5oX5YZ4SpH0ZM1eyMS/8xhXI7pXUa735WXSuLUPm8kSKSDAJRpp42RUTY5GICBKKYpLMOUlzzRAakylzefO+3sJsOnHdK6Y+WSDk58uIxK0Gy5ozdtmkUL0cgsN0S7p7dQ5+dTAYsOqZrjzu1wTKRKIGMnE6h4hsaJ5Q0b7WaAutG9C6FZu/RInViN5sDVpYKDzcP1Eu10cUOrDyvYlax33b7uZzkLLGpD2FXCGbTtNvLKYGIPpz1SRhCOOwIrTRRAkWrhFRwTB4ZMUQ23Fkk1IFaKpD6y5JfR9QbRyP3vL7he8jt3/cgicEjQVYS5P318xTp/UUq+cycoXJR0zZy8c22BEox4ZXqx3P1pA8hVInG89BoEDc3VsEXhZDjgDZArAEyOSJMN9Cge8ngboxP46Dy9H2SX+a68X1mxQhT8vCOKaF0uRTXrJVTc33ahVocaIhxOoosGLCPTFhVhRXFIlzOzyO84x8CayQ0CfXI3A5/Vp6PUbVbxyEPC1yY8pwM3BDlJe+qCIopk9CCD0PqNC4HaRIPa3o3CIcuW4I06GxK5BuUgSl9HqMqt84CHkqc5+Wh+NOHljU0knPt1ODAkS6pGMSeIpORCuG4hVBA4dAm1VGmj2FaFJBh2tBTnYFp5Q3sn7jIOQpzwVIKCVgWRO6Tnq8+JZzwzOdfz4P5HNAzgUcB+A2W6FYmYFSKiAIQL4P9D2g1wf1ekxgH2NZlWPW7xRw7XoIvAxeSOnSSkF6vhL3Yg/JJBknOeJXDe81z4l7Y5U3qn7jwDc89Zi0DnxvctElK/272530yIPvvmuknNvIUpRMnnf0N5lCTmT0fEp53e5Y9RsHXp/nS1pM2j563cLELxRu+sSr2zgEqZOqL+0tBM7bkFIbtev3w9Qb8WuSB3O/ec7eOvFOLsd9lD57Pqp+46DX4UFtj8VtE73uLbNkaRJY5Waqvyn8AG6jgf7c3IlrXu6fUNY+nP53ofoLCCRgmcUuwzCbilSWJUxhB37+bQT2/REfqGHKSwPXb2LSuhUOETFpn6Lfec38TkRavmeCgWkGLlvpynGOewUGTEBg/xS2v4oguAURLIF0BTxIaN2FpkNosYXA/TcCZ2Pk5J3TbKZ4AyG4XpO6UYx+h430T20zVSXlPpqNysSxNKe2jf5OKdWVYr+QlDR+4kmwyn1m0nngPm4gv/N4xJMadm3yYATzwzwBjdhSv4NmY/L4k8j3YVe2R17nhhUfbEF42cT0+T38vtGEwdQnCyk7eMT8/AuJyO0ddNuvo9+7O3FMzak9gg7ckeEhu91Duf0AfrUIv1pBUCiMt/VEazNCOoctOAend+5W4ZGpz6To9xz0OvNRyHtAGodg/ojdzWdw7cYnExfizj+Et6dGBiJh+qCOScq2EJQLkMW86feUZZuRgP1IigwzIQMTwbA6PditLkTw5Ok7q7gPtz5a6sfB7uZ1ww/zdGyO4I/otF5Ds7GbyTyBW9+Bf9BH0EydIxiACXAft4DHGa2TJQm7+hDOTDbhLu7LOi2OAP88zkpGH3hU+lUYaAtOW65wdnDFc4ufQLjZTdacBi6Hy8uKMOaB+WBeEqP2cXLuQMo1bG7cyKgZMNNpuav34M59Zob+iwC/l9/P5WQ1fcdgHqR8PznniVOWj34b1VrNzDJnjWiGHapXgZYjZpTOALL6EPnDC5thf3hvBc1G46zLEhh/RrPxY1i2j/mlbNdzcAPd3I5Zic0TyapbhPLy0H4OWjngPQNGA3g3lIkBKZDZW+CDnD6E2zMxf+Fc3Fbs3a0FNBu89+HXaZdHkcaW9c/Q2P0+lLTNSpqLADdcONz/ZNMHZYHt+0s4ePQF0/6UFUM4w+ru5KK+C1ij9j8EDjdtbayi1dydZFEfogffQbu5jY11Xl45nU21Fw1uF7ev1dyOVgiNJAxnXHPLnexv4fV7uPvRS5hb/Ai1+mi35fOGxt4s9refzXqhcow/QMlt7G5+D62DHSxe24Cbm8r/i5EJvL6D7fur6LbZp/wFgI/O+trz7lh5DUSvoDyzifmlB+fZfDE1BL7A7tYKWrxzRf/5rNKVxNS2+Vw6Mtzmc37S4k2yxzeU1epbKM9MHlrOCq2DEhp7S+h1eFnDcEPZVDfJhjvafof1tXfRbd9Ct81bFyvR1sU9syPushFuXayj256DDA4TWxcz6YOzMyHCvZRrJvEm2dbB8yYd3STbjDfJZoajm2Rn4PVnoGS8Sfbti9gkO7l6PgkjtmPDcdtw3B5s24OT68NxfViW5C3ZsCwNYSkoKSAlQUkLUlpmqtHv5xAELnwvD98rQQY8l9Acezv2//Qe9rABHCUIIwXraw4Cv47An0e3zYvxmNSZaGDheUWuU5xYeuPE9iL3lUwQSw/bimy97+Pm7ewd9lEA8F9mW1vYGO10aAAAAABJRU5ErkJggg==',
                            label: {
                                normal: {
                                    show: false,
                                }
                            },
                            itemStyle: {
                                normal: {
                                    color: 'red', //标志颜色
                                }
                            },
                            zlevel: 5,
                            data: this.coordinateList,
                        },
                        {
                            name: '医院地标',
                            type: 'effectScatter',
                            coordinateSystem: 'geo',
                            symbolSize: [5, 5],
                            label: {
                                normal: {
                                    show: false
                                }
                            },
                            rippleEffect: {
                                brushType: 'stroke',
                                scale: 4,
                                period: 6
                            },
                            itemStyle: {
                                // color: '#33ffff',
                                color: '#12ffae',
                                opacity: 0.7,
                                shadowBlur: 3
                            },
                            zlevel: 4,
                            tooltip: {
                                show: true,
                                backgroundColor: 'rgba(1,12,56,0.71)',
                                borderColor: '#17C7FC',
                                borderWidth: 1,
                                confine: false,
                                padding: 15,
                                enterable: true,
                                extraCssText: 'box-shadow: 0 0 10px #17C7FC inset;',
                                trigger: 'item',
                                position: 'top',
                                formatter: (params) => {

                                    clearInterval(this.intervalArea);

                                    let data = '';
                                    let url = window.location.href;
                                    let goToUrl = url.split('#')[0] + '#/real-time-data-monitor?id=' + params.data.id;
                                    data = `<a href="${goToUrl}" style="color:#fff;text-decoration: none;"><div style="padding:0.2em 0.5em;font-size:0.875em;background-position:center;background-repeat:no-repeat;">
<div style="text-align:center;padding:0 2em;margin-bottom:0.2em;height:2em;line-height:2em;background-size:100% 100%;background-position:center;background-repeat:no-repeat;background-image: url('https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/qkbt.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001585137311&Signature=k508wNsxGOBvt3n9l4U4qzxq8Ck%3D')">${params.data.hospName}</div>
<div style="display: flex;align-items: center;justify-content: space-between;">
    <div style="padding:0.5em 1em 0.5em 0;">
        <div>入网设备数量 <span style="font-size:1.4rem;font-weight:bold;">${params.data.collectorCount} </span>台</div>

    </div>
</div></a>`;
                                    return data;
                                },
                            },
                            data: this.hospitalAreaList
                        },
                        {
                            name: '全国地图',
                            type: 'map',
                            geoIndex: 0,
                            data: this.dataList,
                            zlevel: 6,
                            label:{
                                show:false
                            },
                            tooltip: {
                                show: true,
                                backgroundColor: 'rgba(1,12,56,0.71)',
                                borderColor: '#17C7FC',
                                borderWidth: 1,
                                confine: false,
                                padding: 15,
                                enterable: true,
                                extraCssText: 'box-shadow: 0 0 10px #17C7FC inset;',
                                trigger: 'item',
                                position: 'inside',
                                triggerOn: 'click',
                                alwaysShowContent: false,
                                formatter: (params) => {
                                    console.log(params, '参数');

                                    clearInterval(this.intervalArea);

                                    let data = ''
                                    if (typeof params.data !== 'undefined' && params.data.hospVOList && params.data.hospVOList.length > 0) {
                                        data = `
                            <div>
                                   <div style="width:100%;margin-bottom:0.2em;font-size:1em;color:#fff;display:flex;align-items: center;justify-content: space-between;">
                                                <div>
                                                    ${params.name}
                                                </div>
                                                <div style="margin-left: 20px;">
                                                    共${params.data.hospVOList.length}家
                                                </div>
                                            </div>
                          `
                                        for (let i = 0; i < params.data.hospVOList.length; i++) {
                                            let url = window.location.href;
                                            if(params.data.hospVOList[i].id === '6048334c30e37939ddbb7143'){
                                                let goToUrl = url.split('#')[0] + '#/real-time-data-monitor?id=' + params.data.hospVOList[i].id
                                                data += `<div style="font-size:0.8em;"}>
                    <a href="${goToUrl}" style="margin-bottom:0.5em;color:#FCCD68;width:100%;pointer-events: all; display: inline-block;text-align: center;cursor: pointer">
                    ${params.data.hospVOList[i].hospName}
                  </a>
                    <div/>`
                                            }else{
                                                data += `<div style="font-size:0.8em;"}>
                    <a style="margin-bottom:0.5em;color:#FCCD68;width:100%;pointer-events: all; display: inline-block;text-align: center;cursor: pointer">
                    ${params.data.hospVOList[i].hospName}
                  </a>
                    <div/>`
                                            }

                                        }
                                        data += ` </div>`;
                                    }
                                    return data
                                }
                            }
                        }
                        // {
                        //   name: 'labelType',
                        //   type: 'scatter',
                        //   coordinateSystem: 'geo',
                        //   tooltip: {
                        //     show: false
                        //   },
                        //   symbolSize: [30, 30],
                        //   symbol: 'image://data:image/png;base64,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',
                        //   label: {
                        //     backgroundColor: {
                        //       image: 'data:image/png;base64,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',
                        //     },
                        //     show: false,
                        //     padding: [15, 5, 5, 15],
                        //     position: 'top',
                        //     align: 'left',
                        //     color: '#fff',
                        //     fontSize: 9,
                        //     formatter: (params) => {
                        //       console.log(params, '地标');
                        //       var res = '{title|' + params.data.hospName + '}' + '\n' +
                        //         '{div|}' + '\n' +
                        //         '{content|' + params.data.deptName + '} ' + '{num|'
                        //         + params.data.statusData + '}' + '\n' + '{div|}' + '\n' +
                        //         '{content|' + params.data.eqpName + '}' + '\n' + '{div|}' + '\n' +
                        //         '{time|' + params.data.statusStartDateTime + '}';
                        //       return res;
                        //     },
                        //     rich: {
                        //       title: {
                        //         color: '#fff',
                        //         fontSize: '1em',
                        //         align: 'center',
                        //         backgroundColor: {
                        //           image: 'data:image/png;base64,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'
                        //         },
                        //         padding: [5, 5, 5, 5],
                        //         verticalAlign: 'middle'
                        //       },
                        //       div: {
                        //         height: 10,
                        //       },
                        //       content: {
                        //         color: '#fff',
                        //         fontSize: '0.875rem',
                        //         padding: [0, 10, 0, 0],
                        //         align: 'left',
                        //       },
                        //       num: {
                        //         backgroundColor: {
                        //           image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAA3CAYAAAD6+O8NAAAFAElEQVR4nO2cTY7bRhCF6xUpjVfeTpBVjpF9DuClEfsAOVMO4ABZGjlEfIt4FcRbr+wRuyuoqm6Kolqi4p9JG6gHNCiJFAXVp+ofoV/h5z//+oOI/qbr+kXP/vbjDxuXhS7pxZu3eubXjQB9PxLR+xrw0FfXVpxfjfXRp/76719/CIw36bvmRe+ePbFjySAalyfvX3/4fePWGUTZjyIEEsZjfaFvSEIQgkaGhYjJW1P6g3737Mnzem684VtmJpkYNIEkAZRQgehHh84FB6IwRGgQwpCFxkwYr8HZBMIkDwx6GCAK48AKAzIDQQBpSmgJRGHIIMAuKRShfSbsL733IhAm+TjAmgI5MBwIW5ZIYkvMANKUELJCURiw7BiyYAJhl/SUkGTCXeutTSCaGQpj5BnKobSJPVsydPyIDGnKYViWcBaMyRoleBMbhQ3aeaa0gOTSTTkU5I+jwmB7Pg2WHTaWiIL5f75y31IQ4gEfkmBiwcgZGZY4rIErsOhsTNEXXi5f0AG8BN6yQmGMPEPxcySJYVkSakinO1nAiTDMMBhi0yMSFuhALzqeTKsseTmu1x9lNmVjxlAyo0B52PnzVLIkgFyQASFwEgwpIx0Y2WCwIGfhDBogMjIw6SBPi3XgusvS2VOywRuUSqZMmhkKY8fZno8s2YFEl9WSCFiBTBmZa2awsMOQKQEWX4gksm7sqBMgNp0tU1v2bsnGjALFjgWKPs4MiUG9oSxAEjAYg8LIbHPfKUOGpBOjMlMFoIP8ZSB1Je5gdL1hmZB0zFAImhl63HE2ILEOaUsgYDnJDIthIo+pxVaO/3osb7LKEF3sedMprc2k7O8R76K0KYjaAkhbYp2N/qoFWUrsfBIkdbmwjPXyJqcZ4gs9X4Ef32iDtzfvplCuiS6rrazz2hIfYBE/+1F7bMuP+WxxffV/ldDjK4B0pgDSmQJIZwognSmAdKYA0pkCSGcKIJ0pgHSmANKZAkhnCiCdKYB0pgDSmQJIZwognSmAdKYA0pkCSGcKIJ0pgHSmANKZTvdl6S4h2ypvu4XcdOJb68mb+R2gO/P0Gt1/FDqXO6gsProz6xg/tSCU2JbNdPZ4eYNxxQO1zaYTsRvb5uGyo5ttm6TvBY6Ncg1psDVOaRG37GA8nrPlDdUcOmu9t9dco9Ub50QxJDeeDJP7HHwDse5fjZ2LTdXN1iVmbktQ4yd5TD22bYfuKkOKa3T2xpkdyxxA6nM42VovYUe4pIUdgZPHbnBbm8fUwCgUc+heAeIZ4q5RNSrqTaoDqJpOsptOwrBzRSvDznAQ7FKuXkOMbgJ1u3TNkLlwQH1QHTzqe1MLr7pG1ah4YsdiYfU5hKXtupaWtpIh4+RQ9kkstjshPZ57PM9eUHO7+qnVwmuuUVrbsWRIYfq8qpXps0LZG5Rjq4UElrJaJ69Wxk91h+7VT20WXnKj4tGOFbboLbVt0TOIuyTYF2/h2Tqw6VM3Z2jxU5uFFzSoUdG8cVE4YFvLwgE0Fw6oQLTburtUzeFiJQerNFAoq4XXXaOltIZEaY1rOi+tYQP4rgzon1Zag0qmZK/PMamFV12jZlSM4jNb+jrFZ4q4gNmTjysn5Zke6Qt+W/oP5ZnWOgGyrNt0q6KA2eepFjCruiVDQl9AP93/07zJizenz8fjibebn9oqA7gmHGqrBH6rCOZTBfL0hgujSOaX0fU4EtG/hSOJeKj5Mm8AAAAASUVORK5CYII='
                        //         },
                        //         padding: [5, 5, 5, 5],
                        //         fontSize: '0.875rem',
                        //         align: 'center',
                        //         color: '#FFA800'
                        //       },
                        //       time: {
                        //         color: '#fff',
                        //         fontSize: '0.875em',
                        //         align: 'left',
                        //       }
                        //     },
                        //   },
                        //   zlevel: 2,
                        //   data: arr,
                        // },
                    ]
                };
                eqpChart.resize();
                eqpChart.setOption(options, true);

                // label的方式
                // this.setTimeOutAreaEcharts();

                // tooltips方式
                this.intervalAreaEcharts(eqpChart);

            },

            intervalAreaEcharts(eqpChart) {
                var _this = this;
                eqpChart.dispatchAction({
                    type: 'showTip',
                    seriesIndex: 0,  // 显示第几个series
                    dataIndex: _this.areaIndex// 显示第几个数据
                });
                clearInterval(this.intervalArea);
                this.intervalArea = setInterval(function () {
                    if (_this.areaIndex < _this.coordinateList.length - 1) {
                        _this.areaIndex++;
                    } else {
                        _this.areaIndex = 0;
                    }
                    eqpChart.dispatchAction({
                        type: 'showTip',
                        seriesIndex: 0,  // 显示第几个series
                        dataIndex: _this.areaIndex// 显示第几个数据
                    });
                }, 5000)
            },

            setTimeOutAreaEcharts() {
                var _this = this;
                setTimeout(function () {
                    if (_this.areaIndex < _this.coordinateList.length - 1) {
                        _this.areaIndex++;
                    } else {
                        _this.areaIndex = 0;
                    }
                    _this.setAreaEcharts();
                }, 15000)
            },

            toolTipsHtml() {
                const infoContent = `<span onclick="myClick">这是显示的文本</span>`
                const MyComponent = Vue.extend({
                    template: infoContent,
                    methods: {
                        myClick: function () {
                            console.log('点击事件监听到')
                        }
                    }
                })
                var component = new MyComponent().$mount('#app')
                return component
            },
            intervalIotEcharts() {
                clearInterval(this.iotInterval);
                this.iotList.reverse();
                this.initIotEcharts(this.iotList.slice(length - 6));
                if (this.iotList.length > 6) {
                    this.$nextTick(() => {
                        this.iotInterval = setInterval(() => {
                            this.iotList = this.iotList.slice(length - 1).concat(this.iotList.slice(0, length - 1));
                            this.initIotEcharts(this.iotList.slice(length - 6));
                        }, this.speed)
                    })
                }
            },
            initIotEcharts(list) {
                var obj = {
                    nameList: [],
                    series1: [],
                    series2: [],
                    series3: [],
                };
                for (var i = 0; i < list.length; i++) {
                    obj.nameList.push(list[i].placeName);
                    obj.series1.push(list[i].allCount);
                    obj.series2.push(list[i].warningCount);
                    // obj.series1.push(2);
                    // obj.series2.push(8);
                    obj.series3.push(i);
                }

                var echarts = this.$echarts.init(document.getElementById('iotPointsChart'));
                var options = {
                    legend: {
                        data: ['总数', '预警'],
                        itemWidth: 10,
                        itemHeight: 10,
                        right: 5,
                        textStyle: {
                            //图例文字的样式
                            color: "#ffffff",
                            fontSize: '0.875em'
                        }
                    },
                    grid: {
                        top: '6%',
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'value',
                        axisLine: {
                            show: false,
                        },
                        splitLine: {
                            show: false
                        },
                        axisLabel: {
                            show: false
                        },
                        axisTick: {
                            //坐标轴刻度相关设置。
                            show: false
                        },
                        boundaryGap: [0, 0.01]
                    },
                    yAxis: {
                        type: 'category',
                        axisLine: {
                            show: false
                        },
                        axisLabel: {
                            show: true,
                            color: '#fff',
                            margin: 15,
                            fontSize: '0.875em'
                        },
                        axisTick: {
                            //坐标轴刻度相关设置。
                            show: false
                        },
                        splitLine: {
                            show: false
                        },
                        data: obj.nameList
                    },
                    series: [
                        {
                            name: '总数',
                            type: 'bar',
                            label: {
                                normal: {
                                    show: true,
                                    position: 'right',
                                    color: "#60D4E6",
                                    fontSize: '0.875em'
                                }
                            },
                            itemStyle: {
                                //图形样式
                                normal: {
                                    color: '#60D4E6'
                                }
                            },
                            barWidth: 7,
                            barGap: '0.5',
                            data: obj.series1
                        },
                        {
                            name: '预警',
                            type: 'bar',
                            label: {
                                normal: {
                                    show: true,
                                    position: 'right',
                                    color: "#FF5D00",
                                    fontSize: '0.875em'
                                }
                            },
                            itemStyle: {
                                //图形样式
                                normal: {
                                    color: '#FF5D00'
                                }
                            },
                            barWidth: 7,
                            barGap: '0.5',
                            data: obj.series2
                        },
                        {
                            type: "pictorialBar",
                            symbol: "image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAdCAYAAACaCl3kAAAAtUlEQVQ4jZ3VPQrCQBBA4RfRSktrDyDewCPoBUwbsNFKEWtvZuFVvIWFBDawLDuzMxNINXy8wP6k4/xFePbARxrOpAHwVGYi3ALHCBxrnRdugJOGJHgDFl64BoYWqsELsPLCJXC1oBIO6VNdcA7crSiHfVoGFxwX+uFBEzwAuwhUN7MGf1H4isJ3et2QSHWC7mq+5VzVHLqq5bEyV0tortauDlO1Bk1V6XpsViXYrGq/ALkK/AH1vhaJrdU2IgAAAABJRU5ErkJggg==",
                            symbolSize: [8, 16],
                            symbolRotate: 0,
                            symbolOffset: [-10, 0],
                            symbolBoundingData: 300,
                            data: obj.series3,
                            zlevel: 100,
                            z: 100
                        }
                    ]
                };
                echarts.resize();
                echarts.setOption(options, true);
            },
            resizePage() {
                var x = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
                var y = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
                console.log(x, '宽')
                console.log(y, '高')
                this.screenWidth = x + 'px'
                var val = parseFloat((x / y).toFixed(1))
                console.log(val, '比例')
                if (val < 1.78) {
                    console.log('宽为准')
                    // 以宽为准
                    this.viewWidth = x + 'px'
                    this.viewHeight = parseInt(x / (1.78)) + 'px'
                    this.fontsize = parseInt(x / (1920 / 16)) + 'px'
                } else {
                    console.log('高为准');
                    // 以高为准
                    this.viewHeight = '100%';
                    this.viewWidth = parseInt(y * 1.77) + 'px';
                    this.fontsize = parseInt((y * 1.77) / (1920 / 16)) + 'px';
                }
                this.viewWidth = x + 'px';
                this.viewHeight = y + 'px';
                this.$nextTick(() => {
                    this.initPage();
                });
            },
            collectorStatusQuery() {
                collectorStatusQuery({}).then(res => {
                    this.stateNumList = res;
                }).catch(err => {

                })
            },
            eqpWarnStatusQuery(){
                eqpWarnStatusQuery({}).then(res => {
                    this.eqpStateNumList = res;
                }).catch(err => {

                })
            },
            // 实时监控预警数据
            hospCollectorWaringQuery() {
                hospCollectorWaringQuery({}).then(response => {
                    this.warningList = response;
                    this.$refs.warningView.ScrollUp();
                    eqpWarnLogListQuery({}).then(resp => {
                        this.eqpWarningList=resp;
                        this.$refs.eqpWarningView.ScrollUp();
                        // 地图数据展示
                        this.coordinateList = JSON.parse(JSON.stringify(response.concat(resp)));
                        this.coordinateList.forEach(option => {
                            option.value = [option.longitude, option.latitude];
                        });
                        console.log(this.coordinateList,'000000000000000000000000000');
                        // 获取地图蓝色标注
                        mapHospQuery({}).then(res => {
                            this.hospitalAreaList = res;
                            this.hospitalAreaList.forEach(option => {
                                option.value = [option.longitude, option.latitude];
                            });
                            // 获取各省份医院数据
                            provinceHospQuery(
                                {
                                    pagedQueryInfo: {
                                        index: 1,
                                        pageSize: 9999
                                    }
                                }
                            ).then(res => {
                                this.dataList = res;
                                this.setAreaEcharts();
                            }).catch(err => {

                            })
                        }).catch(err => {

                        });
                    }).catch(err => {

                    });
                }).catch(err => {
                    this.setAreaEcharts();
                })
            },
            iotPlatformInfo() {
                iotPlatformInfo({}).then(res => {
                    this.dataDetail.hospSum = res.hospCount;
                    this.dataDetail.eqpSum = res.eqpCount;
                }).catch(err => {

                });
            },
            // 更新页面
            initPage() {
                this.initAreaEcharts();
                // 采集器所属地区列表实时状态查询
                this.collectorStatusQuery();
                this.eqpWarnStatusQuery();
                this.iotPlatformInfo();
                this.queryHospCollectCount();
                clearInterval(this.interval);
                this.interval=setInterval(() => {
                    this.initAreaEcharts();
                    // 采集器所属地区列表实时状态查询
                    this.collectorStatusQuery();
                    this.eqpWarnStatusQuery();
                    this.iotPlatformInfo();
                    this.queryHospCollectCount();
                },15000);
            },
            // 获取用户下所有医院以及医院下设备的数量
            queryHospCollectCount() {
                var req = {
                    pagedQueryInfo: {
                        index: 1,
                        pageSize: 9999
                    }
                };
                queryHospCollectCount(req).then(res => {
                    res.list.forEach(option => {
                        option.hospName = option.hospName + '(' + option.collectorCount + ')';
                    });
                    this.hospitalList = res.list;
                    this.list = res.list;

                }).catch(err => {

                });
            },
            chooseHospital(item) {
                console.log(item, 'item');
                if("6048334c30e37939ddbb7143" === item.id){
                    this.$router.push({path: '/real-time-data-monitor', query: {id: item.id}});
                }else{
                    errorNotify("您无访问权限")
                }
            },
        },
        mounted() {
			console.log('routers')
            window.onresize = () => {
                return (() => {
                    var elem = document.getElementById("areaCockpit");
                    if (!elem) {

                    } else {
                        console.log("屏幕变化大小");
                        this.resizePage();
                    }
                })();
            };
            this.resizePage();

            // animated增加动效
            // document.getElementsByClassName('bottom_left')[0].className = ('bottom_left animated fadeInLeftBig');
            // document.getElementsByClassName('bottom_right')[0].className = ('bottom_right animated fadeInRightBig');
        },
        created() {
			console.log('跳转',)
		    for (let i = 0;i<this.routers[0].children.length;i++) {
				if (this.routers[0].children[i].path === '/data-platform') {
					
					return;
				} else{
					
					this.$router.push({path: '/h-mon-lg-scrn',});
					console.log('/h-mon-lg-scrn')
					return;
				}
		    	
		    }
        },
        destroyed() {
            console.log("=========================清除计时器=====================");
            clearInterval(this.iotInterval);
            clearInterval(this.interval);
        },
		beforeDestroy(){
			clearInterval(this.iotInterval);
			clearInterval(this.interval);
		}
    }
</script>
<style scoped>
    @import '../../style/animate.min.css';

    div {
        box-sizing: border-box;
    }

    .bgView {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        background-image: url('https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/bg.gif?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1000000001585019100&Signature=NkgHMAEukexclsK9y43rMO0%2B%2Bx4%3D');
        background-size: cover;
        background-position: center;
        color: #fff;
        font-size: 1rem;
    }

    .bg {
        width: 100%;
        height: 100%;
        display: flex;
        /*align-items: center;*/
        justify-content: center;
        align-items: center;
        flex-direction: column;
        background-image: url('https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/biankuang.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1000000001585019100&Signature=HN4twTj7MKcIJKRpS3xKMj3lNW4%3D');
        background-size: 100% 100%;
        background-position: center;
    }

    .bk {
        width: 100%;
        height: 100%;
        display: flex;
        /*align-items: center;*/
        justify-content: center;
        align-items: center;
        flex-direction: column;
        background-image: url('https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/bg.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001585019161&Signature=CP6UZfNtH2CMXCrSAk8t9juycEQ%3D');
        background-size: cover;
        background-position: center;
        color: #fff;
    }

    .containerView {
        position: relative;
        /*background-color: transparent;*/
        /*padding: 0 2.8%;*/
    }

    .bottomDiv {
        width: 100%;
        height: 85%;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .bottom_left {
        position: absolute;
        z-index: 2;
        left: 3%;
        top: 10%;
        height: 85%;
        width: 20%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
    }

    .bottom_center {
        /*width: 45.9%;*/
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
    }

    .b-c-t {
        height: 18%;
        font-size: 1rem;
        text-align: center;
        position: absolute;
        /*z-index: 2;*/
    }

    .b-c-t-t {
        margin-bottom: 2.7%;
    }

    .b-c-t > div {
        margin: 0 4rem;
    }

    .f-s-50 {
        font-size: 2rem;
    }

    .b-c-c {
        width: 100%;
        height: 100%;
        position: relative;
        z-index: 1;
        /*background-color:red;*/
    }

    .b-c-c-b {
        position: absolute;
        bottom: 5%;
        left: 15%;
        width: 70%;
        height: 23%;
        z-index: 0;
        background-image: url('https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/dbzp.gif?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=10001585047259&Signature=y6CUV7k5ATXWsob81kkTkeUiKPc%3D');
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }

    #areaEcharts {
        width: 100%;
        height: 100%;
    }

    .bottom_right {
        /*width: 19.3%;*/
        position: absolute;
        right: 3%;
        width: 20%;
        z-index: 2;
        top: 10%;
        height: 85%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
    }

    .lastMonthData > .divTitle {
        width: 49.9%;
        height: 22.22%;
    }

    .lastYearData > .divTitle {
        width: 29.9%;
        height: 16.13%;
    }

    .waitRpaireData > .divTitle {
        width: 29.9%;
        height: 6.77%;
    }

    .eqpState > .divTitle {
        width: 70.97%;
        height: 16.33%;
    }

    .workControl > .divTitle {
        width: 70.97%;
        height: 6.86%;
    }

    @keyframes rotateFrame {
        0% {
            transform: rotate(0);
        }

        50% {
            transform: rotate(-180deg);
        }

        100% {
            transform: rotate(-360deg);
        }
    }

    .serviceTj > div {
        margin: 0 15%;
    }

    .waitRpaireTable > div {
        width: 13%;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .teamRpaireTable > div {
        width: 11%;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .teamRpaireTable > div:nth-child(6) {
        width: 16%;
    }

    .teamRpaireTable > div:nth-child(8) {
        width: 16%;
    }

    .workMonitoringItem_left > div:nth-child(1) {
        /*font-size:1.25em;*/
        margin-bottom: 0.87rem;
    }

    .workMonitoringItem_left > div:nth-child(2) {
        margin-bottom: 0.87rem;
    }

    .operationView {
        position: absolute;
        left: 0;
        top: 4%;
        height: 4%;
        width: 100%;
        padding: 0 3%;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    @keyframes rotateFrame {
        0% {
            transform: rotate(0);
        }

        50% {
            transform: rotate(-180deg);
        }

        100% {
            transform: rotate(-360deg);
        }
    }

    .stateNum > span {
        font-size: 1rem;
    }

    .stateDiv {
        width: 100%;
        height: 45%;
        /*background-color:pink;*/
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-direction: column;
    }

    .stateItem {
        width: 100%;
        height: 100%;
        /*background-image: url("https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/zhengchang_ic.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=10000001585029770&Signature=eAEKcWmeECTxzIIUQ9kvqN2%2BGaQ%3D");*/
        /*background-size: 100% 100%;*/
        /*background-repeat: no-repeat;*/
        /*background-position: center;*/
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 20% 0 40%;
        font-size: 1rem;
    }

    .iotPoints {
        width: 100%;
        height: 53%;
        background-image: url("https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/qgwlwjd.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001585030814&Signature=o%2Fib78rPKJQ4LyL2R4%2Bp2QoOUwk%3D");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;
        padding: 1.125em;
    }

    .div_top_title {
        font-size: 1.125em;
        margin-bottom: 5%;
    }

    #iotPointsChart {
        width: 100%;
        height: 100%;
        font-size: 1em;
        /*background-color:pink;*/
    }

    .entranceView {
        width: 14em;
        height: 3em;
        background-image: url("https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/pcweblogin.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=10001587457377&Signature=h05jVSwp74ZuP%2Fkg2DAc73XggZc%3D");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;
        margin-right: 1em;
    }

    .c-pointer {
        cursor: pointer;
    }

    .workBench {
        width: 12em;
        height: 3em;
        background-image: url("https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/gzt.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=100001585040255&Signature=bXsn5TkWA%2BWhqrrUMaTzanmHNv0%3D");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;
    }

    .now_bottom_right {
        width: 100%;
        height: 100%;
        background-image: url('https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/ssyjjk.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001585117604&Signature=pOjeZikr7h8%2BkGCkn34SWVtLKqM%3D');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;
        padding: 1.125em 1.5em;
    }

    .warningSum {
        width: 50%;
        text-align: center;
        line-height: 2em;
        height: 2em;
        font-size: 0.875em;
        background-image: url('https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/yjjk_sl.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001585118184&Signature=kk1x4IZrKkQIJ3Dos1tCSfgKR6g%3D');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;
        margin-bottom: 1em;
    }

    .warningList {
        width: 100%;
        height: 90%;
        padding: 0em 1em 1em 1em;
        /*background-color:pink;*/
    }

    .warningItem {
        padding-bottom: 0.5em;
        border-bottom: 1px solid rgba(96, 212, 230, 0.4);
        line-height: 2em;
        margin-bottom: 1em;
    }

    .hospName {
        font-size: 1em;
        color: #0DFAFF;
    }

    .waringIcon {
        width: 5em;
        height: 5em;
        background-image: url('https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/unlock_ic.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=10001585118550&Signature=EJFnBkK9uaWcq8Y4kv6FFh%2B%2F20s%3D');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;
    }

    .setUp {
        width: 2em;
        height: 2em;
        background-image: url('https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/shezhi.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001585121738&Signature=0tFLpeuVNJHLsTSLWooOG7WRgx4%3D');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;
        cursor: pointer;
    }

    .selectHospital {
        width: 16em;
        height: 3em;
        /*background-image: url("https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/czyysb.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1000001588924355&Signature=8lxrzNL8eJaWBSu5FpwgIeUIGio%3D");*/
        background-image: url("https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/queryBg.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001589858703&Signature=4hSNr4htpAYUPyNjX4aW9zV%2BXm4%3D");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;
    }

    .setUpView {
        background-image: url("https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/setbg.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=10001589005699&Signature=AYTmdo3R%2FR4dLL%2FjFcKtmeU8FBQ%3D");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;
        height: 3em;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 1em;
        padding: 0 1em;
    }

    ::-webkit-input-placeholder {
        color: #fff;
        font-style: italic;
        font-weight: bolder;
    }

    .listView::-webkit-scrollbar {
        width: 6px;
    }

    .listView::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: rgba(0, 0, 0, 0.2);
    }

    .listView::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 0;
        background: rgba(0, 0, 0, 0.1);
    }

    .statsDiv{
        width:100%;
        height:25%;
        background-image: url("https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/bk-short.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=10001605161309&Signature=2%2FwLRhZltvFdI1wiJN%2BURTgXO4s%3D");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;
        padding: 1.125em 1.5em;
    }

    .realTimeData{
        width:100%;
        height:72%;
        background-image: url("https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/bk_long.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=10001605237787&Signature=BxlNC3dcN2P8yxinaKZYqezvMMg%3D");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;
        padding: 1.125em 1.5em;
    }

    .rotate_img{
        width:5em;
        animation: rotateFrame 4000ms linear infinite;
    }

    .runingState{
        width:100%;
        height:25%;
        background-image: url("https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/bk-short.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=10001605161309&Signature=2%2FwLRhZltvFdI1wiJN%2BURTgXO4s%3D");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;
        padding: 1.125em 1.5em;
    }

</style>
